import { render, staticRenderFns } from "./searchUserToHc.vue?vue&type=template&id=88c58806&"
import script from "./searchUserToHc.vue?vue&type=script&lang=js&"
export * from "./searchUserToHc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports